import React, { useState, useContext, createContext, useEffect } from "react";
import axios from 'axios';
import { useLocation } from "react-router-dom";
import { ModuleRefreshSettingServices, InstitutionServices } from '../Services.js';

const authContext = createContext();

function ProvideAuth({ children }) {
    const auth = useProvideAuth();
    return (
        <authContext.Provider value={auth}>
            {children}
        </authContext.Provider>
    );
}

const aafAuth = {
    isAuthenticated: false,
    signin() {
        return axios.get('api/auth', {}, { withCredentials: true })
            .then(response => {
                aafAuth.isAuthenticated = true;
                return response.data;
            })
            .catch(error => {
                aafAuth.isAuthenticated = false;
                throw error.response;
            });
    },
    signout() {
        return axios.get('api/auth/logout', {}, { withCredentials: true })
            .then(response => {
                aafAuth.isAuthenticated = false;
                return response;
            });
    }
};

function useAuth() {
    return useContext(authContext);
}

function useProvideAuth() {
    const [user, setUser] = useState(null);
    const [loginURL, setLoginURL] = useState(null);
    const [refreshCycles, setRefreshCycles] = useState([null, null, null, null]);
    const [allowSelfReset, setAllowSelfReset] = useState(null);
    const location = useLocation();
    //store in local storage so user doesn't have to wait for login request before seeing logged in stuff
    const updateUser = (u) => {
        if (u)
            localStorage.setItem("eo_user", JSON.stringify(u));
        else
            localStorage.removeItem("eo_user");
        setUser(u);
        
    };

    //signin, if fails (401) then redirect user to aaf login url
    const signin = () => {
        return aafAuth.signin().then(response => {
      
            updateUser(response.user);            
            return response;
        })
            .catch(response => {              
                if (loginURL) {   
                window.location = loginURL;
            }
            updateUser(null);
            throw response;
        });
    };

    //signout, get login url if it has not already been fetched so user can login again
    const signout = () => {
        return aafAuth.signout().then(response => {
            updateUser(null);
            if (!loginURL)
                getLoginURL();
            return response;
        });
    };

    //useful when preventing user signing in before login url has been fetched
    //(e.g.don't show login button unless user can safely click it)
    const canLogin = () => {
        return loginURL != null;
    };

    const getLoginURL = () => {
        axios.get('api/util/loginURL', {}, { withCredentials: true })
            .then(response => {
                setLoginURL(response.data);
            }).catch(response => {

            });
    };

    //on initialisation, load the previous user and then attempt to get the user's server authentication state.
    //if user is not logged in, then get the login url
    useEffect(() => {
        //if user has logged in, assume they are still logged in until the useffect has finished
        var stored = localStorage.getItem("eo_user");
        try {
            stored = stored ? JSON.parse(stored) : null;
        }
        catch {
            stored = null;
        }
        updateUser(stored);


        //on first load, check if signed in. if not, then fetch login url and wait for user to request login
        signin().then(response => {
            //signin has taken care of setting user 

       
        }).catch(() => {
            getLoginURL();
        });
        ModuleRefreshSettingServices.getCycles().then(response => { 
            var arr = [null, null, null, null];
            response.data.forEach((i) => {         
                arr[i.moduleID - 1] = i.refreshSetting == 0 ? null : i.refreshSetting;
            });
            setRefreshCycles(arr);
         //   console.log(arr);
        });
        InstitutionServices.getAllowSelfReset().then(response => {
            setAllowSelfReset(response.data);
        });

    }, []);
  

    return {
        user,
        canLogin,
        signin,
        signout, 
        refreshCycles,
        allowSelfReset
    };
}

export default useAuth;
export { ProvideAuth };